import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-muscle-beach',
    templateUrl: './muscle-beach.component.html',
    styleUrls: ['./muscle-beach.component.scss'],
    standalone: false
})
export class MuscleBeachComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
